import React, { useState, useEffect } from "react";
import genericAction from "@Actions/generic";

// PropTypes
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import { Dropdown } from "semantic-ui-react";
import IKModal from "@Components/IkModal";
import InputFilter from "@Components/InputFilter";
import ConfirmModal from "@Modals/ConfirmModal";

// Utils
import { map, filter } from "lodash";
import dataHandler from "@Utils/dataHandler";

// Static Data
import { contactOption } from "./staticData";

// Styles
import styles from "./styles.module.css";

const ModalPlantilla = ({ onClose, channel, contact, channelsData, dispatch, tableValue, refresh, isReadOnly }) => {
	const [openConfirm, setOpenConfirm] = useState(false);

	const [channels, setChannels] = useState([]);
	const [selectedChannel, setSelectedChannel] = useState(null);
	const [contacts, setContacts] = useState({});
	const [templates, setTemplates] = useState([]);
	const [selectedTemplate, setSelectedTemplate] = useState(null);

	const [errors, setErrors] = useState({
		channel: "",
		contact: "",
		template: "",
	});

	useEffect(() => {
		const init = async () => {
			setSelectedChannel(channel?.id || null);
			setContacts(contact?.id ? { id: contact.id, name: contact.name } : {});
			setSelectedTemplate(tableValue?.templateId || null);

			if (channelsData) {
				const mappedChannels = map(channelsData, (item) => {
					return {
						key: item.id,
						value: item.id,
						text: item.label,
					};
				});
				setChannels(mappedChannels);
			}

			const response = await dataHandler({ dispatch, method: "GET", url: "/templates" });
			const activeTemplates = filter(response.items || [], (tpl) => {
				return tpl.isActive;
			});

			if (selectedChannel) {
				const filteredTemplates = activeTemplates.filter((tpl) => {
					return tpl.channelId === selectedChannel;
				});

				const mappedTemplates = map(filteredTemplates, (tpl) => {
					return {
						key: tpl.id,
						value: tpl.id,
						text: tpl.title,
					};
				});
				setTemplates(mappedTemplates);
			} else {
				setTemplates([]);
			}
		};

		init();
	}, [channel, contact, tableValue, channelsData, dispatch, selectedChannel]);

	const handleCancel = () => {
		if (!selectedChannel || !contacts?.id || !selectedTemplate) {
			onClose();
		} else {
			setOpenConfirm(true);
		}
	};

	const handleConfirmClose = () => {
		setOpenConfirm(false);
		onClose();
	};

	const onSuccess = () => {
		setSelectedChannel(null);
		setContacts({});
		setSelectedTemplate(null);
		setErrors({ channel: "", contact: "", template: "" });
		refresh?.();
		onClose();
	};

	const handlerSaved = async () => {
		if (!selectedChannel || !contacts?.id || !selectedTemplate) {
			setErrors({
				channel: !selectedChannel ? "El canal es requerido" : "",
				contact: !contacts?.id ? "El contacto es requerido" : "",
				template: !selectedTemplate ? "La plantilla es requerida" : "",
			});
			return;
		}

		const payload = {
			channelId: selectedChannel,
			contactIds: [contacts.id],
			templateId: selectedTemplate,
		};

		await dispatch(
			genericAction({
				method: "post",
				route: "templates/send",
				body: payload,
				onSuccess: () => {
					onSuccess();
					onClose();
				},
			})
		);
	};

	const isFormValid = selectedChannel && contacts.id && selectedTemplate;

	return (
		<>
			<IKModal
				title="Enviar Plantilla"
				onClose={handleCancel}
				onSuccess={handlerSaved}
				saveLabel="Enviar"
				saveDisabled={!isFormValid}
				cancelLabel="Salir"
				onCancel={handleCancel}
				size="tiny"
				fullHeight>
				<div className={styles.grid}>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Canal</legend>
						<Dropdown
							placeholder="Selecciona un canal"
							fluid
							selection
							options={channels}
							value={selectedChannel}
							onChange={(e, { value }) => {
								return setSelectedChannel(value);
							}}
							disabled={isReadOnly}
						/>
						{errors.channel && <span className={styles.error}>{errors.channel}</span>}
					</fieldset>

					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Contacto</legend>
						<InputFilter
							contactData={contacts}
							selectedContact={setContacts}
							onEmpty={() => {
								return setContacts({});
							}}
							url="contacts"
							defaultField="all"
							forceInputValue="name"
							selectTitle="Seleccionar Contacto"
							tableColumns={contactOption}
							disabled={isReadOnly}
						/>
						{errors.contact && <span className={styles.error}>{errors.contact}</span>}
					</fieldset>

					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Plantilla</legend>
						<Dropdown
							placeholder="Selecciona una plantilla"
							fluid
							selection
							clearable
							options={templates}
							value={selectedTemplate}
							onChange={(e, { value }) => {
								return setSelectedTemplate(value);
							}}
						/>
						{errors.template && <span className={styles.error}>{errors.template}</span>}
					</fieldset>
				</div>
			</IKModal>

			{openConfirm && (
				<ConfirmModal
					buttonLabel="Salir"
					visible
					header="Confirmar"
					fullContent="¿Deseas salir sin guardar los cambios?"
					onConfirm={handleConfirmClose}
					onDismiss={() => {
						return setOpenConfirm(false);
					}}
				/>
			)}
		</>
	);
};

ModalPlantilla.propTypes = {
	onClose: PropTypes.func,
	channel: PropTypes.object,
	contact: PropTypes.object,
	dispatch: PropTypes.func,
	channelsData: PropTypes.array,
	tableValue: PropTypes.object,
	refresh: PropTypes.func,
	isReadOnly: PropTypes.bool,
};

function mapStateToProps({ company }) {
	return {
		channelsData: company.channels,
	};
}

export default connect(mapStateToProps)(ModalPlantilla);
